import declare from "dojo/_base/declare";
import _ from "csi/_base/underscore";
import html from "csi/html";
import xml from "csi/xml";
import NewPaneForm from "./NewPaneForm";
import HomePageUtil from "./util";
import { Field } from "csi/def/Field";
import NewItemPaneForm from "./NewItemPaneForm";
import { HomePage } from "../HomePage";

const PANE = "DashboardPane";

const CONTEXT_TYPE = "DashboardPaneContextType";

const NewSupplierPortalPaneForm = declare(NewItemPaneForm, {
	/**
	 * @override
	 * DashboardPaneContextType field is static and will always show label for state attribute.
	 */
	_resolveView(): void {
		this.addFixedValue(CONTEXT_TYPE, HomePageUtil.GLOBAL_CONTEXT);
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Supplier Portal context type will always be set to State, so just update available states based on chose pane.
	 */
	_updateContextTypes(): void {
		this._updateContextTypeWithState();
		this._updateContextWithState();
	},

	/**
	 * @override
	 * Hide context fields if chosen pane has no state.
	 */
	_updateFieldVisibility(field: Field): void {
		if (field) {
			const pane = this.getFieldValue(PANE);
			const sourceView = this.getSourceView();
			const homepageView = sourceView as HomePage;
			const rc = homepageView.getPaneClass(pane);
			this.setFieldHidden(CONTEXT_TYPE, rc && !HomePageUtil.hasStateEnum(rc));
		} else {
			this._updateContextTypeWithState();
		}
	},
});

export = NewSupplierPortalPaneForm;